export default {"src":"/_next/static/media/nextjs.f232a8be.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};